/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { Skeleton } from '#UNSAFE_Skeleton';
import { classNames } from '#utils/UNSAFE_classNames';
import { Size, sizeToCSS } from '#utils/UNSAFE_size';
import {
  baseSkeletonContainerStyles,
  baseStyles,
  skeletonContainerStyles
} from './themes/VisSkeletonStyles.css';

type Props = {
  /**
   * The visualization type.
   */
  type: 'bar' | 'area' | 'line' | 'combo' | 'pie';

  /**
   * The width of the skeleton.
   */
  width?: Size;

  /**
   * The height of the skeleton.
   */
  height?: Size;
};

/**
 * Skeleton loading for visualizations.
 */
export function VisSkeleton({ type, width, height }: Props) {
  return (
    <div
      class={baseStyles}
      style={{
        width: width && sizeToCSS(width),
        height: height && sizeToCSS(height)
      }}>
      <div class={classNames([baseSkeletonContainerStyles, skeletonContainerStyles[type]])}>
        <Skeleton width="100%" height="100%" />
      </div>
    </div>
  );
}
